import http from "./http-common";

const get=(productid)=>{
  return http.get(`/getFavoriteProduct/${productid}`);
}
const FavouriteService = {
  get
};

export default FavouriteService;